import React      from 'react';
import CSSModules from 'react-css-modules';
import moment     from 'moment';

import style from './style.scss';

import Input        from '../Input';
import InlineError  from '../InlineError';
import Label        from '../Label';
import InputGroup   from '../InputGroup';
import InputSection from '../InputSection';
import Button       from '../Button';
import SelectBox    from '../SelectBox';
import Checkbox     from '../Checkbox';
import ValueInput   from '../PromotionValueInput';

import responseFormatter from '../../services/responseFormatter';
import promotionRepo     from '../../services/promotionCodes';

import * as selectCourseActions from '../../actions/selectCourse';

import { reduxForm } from 'redux-form';

const getPromotionExpiryDate = (promotion) => {

    if (!promotion.expires)
        return null;

    return moment(promotion.expiry_date).format('YYYY-MM-DD')
};

class PromotionForm extends React.Component {

    componentDidMount() {

        this.props.refreshCourses();

        if (this.props.mode === 'edit') {

            this.props.initializeForm({
                ...this.props.promotion,
                expiry_date: getPromotionExpiryDate(this.props.promotion)
            });
        }
    }

    _createPromotionCode(values) {

        const formMode = this.props.mode;

        values = this._setParams(values);

        return new Promise((resolve, reject) => {

            const failed = (res) => reject(responseFormatter.apiErrorsToFormErrors(res.data.errors));

            const save = formMode === 'add' ? promotionRepo.create : promotionRepo.update;

            save(values)
                .then(resolve, failed);
        });
    }

    _setParams(values) {

        values.limited_to_course = values.limited_to_course_id !== '0';

        if (values.limited_to_course_id === '0') {

            values.limited_to_course_id = null;
        }

        if (!values.expires) {
            values.expiry_date = null;
        }

        if (this.props.mode === 'edit') {
            values.id = this.props.promotionToEdit.id;
        }

        return values;
    }

    _getPromotionValueSection() {

        return (
            <InputSection>
                <InputGroup>
                    <Label>{ promotionRepo.typeToDescription(this.props.fields.type.value) }</Label>
                    <ValueInput { ...this.props } errors={ this.props.fields.value.error } />
                    <InlineError errors={ this.props.fields.value.error } />
                </InputGroup>
            </InputSection>
        );
    }

    _getExpiryDateInput() {

        if (this.props.fields.expires.value === false)
            return null;

        return (
            <div>
                <Input { ...this.props.fields.expiry_date } errors={ this.props.fields.expiry_date.error } type="date" />
                <InlineError errors={ this.props.fields.expiry_date.error } />
            </div>
        )
    }

    render() {

        const {
            fields: {
                code,
                type,
                one_time_use,
                expires,
                limited_to_course_id
            },
            handleSubmit,
            submitting
        } = this.props;

        return (
            <form onSubmit={ handleSubmit(this._createPromotionCode.bind(this)) }>

                <InputSection>

                    <InputSection>
                        <InputGroup>
                            <Label>Type</Label>

                            <SelectBox { ...type } errors={ type.error }>
                                <option value="fixed_value">Fixed Value</option>
                                <option value="fixed_percentage">Fixed Percentage</option>
                            </SelectBox>

                            <InlineError errors={ type.error } />
                        </InputGroup>
                    </InputSection>

                    <InputSection>
                        <InputGroup>
                            { this._getPromotionValueSection() }
                        </InputGroup>
                    </InputSection>

                    <InputSection>
                        <InputGroup>
                            <Checkbox { ...one_time_use } />
                            <Label>One-time Use</Label>
                            <InlineError errors={ one_time_use.error } />
                        </InputGroup>
                    </InputSection>

                    <InputSection>
                        <InputGroup>
                            <Checkbox { ...expires } />
                            <Label>Expires</Label>
                            <InlineError errors={ expires.error } />
                            { this._getExpiryDateInput() }
                        </InputGroup>
                    </InputSection>

                    <InputSection>
                        <InputGroup>
                            <Label>Limited to Course</Label>

                            <SelectBox { ...this.props.fields.limited_to_course_id } errors={ limited_to_course_id.error }>
                                <option value={ 0 }>Any</option>
                                {
                                    this.props.courses.map((course) => {

                                        return <option key={ course.id } value={ course.id }>{ course.name }</option>
                                    })
                                }
                            </SelectBox>

                            <InlineError errors={ limited_to_course_id.error } />
                        </InputGroup>
                    </InputSection>

                    <InputSection>
                        <InputGroup>
                            <Label>Code</Label>
                            <Input { ...code } errors={ code.error } />
                            <InlineError errors={ code.error } />
                        </InputGroup>
                    </InputSection>

                </InputSection>

                <Button disabled={ submitting } theme="success" type="submit">
                    <span>Save</span>
                </Button>
            </form>
        );
    }
}

const formOptions = {
    form: 'new-promo-code',
    fields: [
        'one_time_use',
        'expires',
        'expiry_date',
        'limited_to_course_id',
        'value',
        'type',
        'code'
    ]
};

function mapStateToProps(state) {

    return {
        ...state.promotionList,
        ...state.selectCourseList,
        initialValues: {
            id: 0,
            one_time_use: true,
            expires: false,
            expiry_date: null,
            limited_to_course_id: '0',
            value: null,
            type: 'fixed_value',
            code: ''
        }
    };
}

function mapDispatchToProps(dispatch) {

    return {
        refreshCourses() {

            dispatch(selectCourseActions.refreshCourses());
        }
    }
}

export default reduxForm(formOptions, mapStateToProps, mapDispatchToProps)(CSSModules(PromotionForm, style));


// WEBPACK FOOTER //
// ./components/PromotionForm/index.js